import { DOCUMENT, Location, PlatformLocation } from '@angular/common';
import { Component, Inject, Optional, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiInventoryService } from '@core/services/api/api-inventory.service';
import { ButtonHandlerService } from '@core/services/button-handler.service';

import { ClientService } from '@core/services/client/client.service';
import { GlobalService } from '@core/services/common/global.service';
import { StyleService } from '@core/services/common/styles/style.service';
import { ListComponent } from '@modules/creator/components/special-block/list/list.component';
import { LoaderService } from '@modules/loaders/services/loader.service';
import { FiltersService } from '@shared/services/filters/filters.service';
import { LocalStorageService, SessionStorageService } from '@shared/services/storage';

@Component({
    selector: 'app-inventory-list',
    templateUrl: '../list/list.component.html',
    styleUrls: ['../list/list.component.scss'],
    providers: [FiltersService],
    standalone: false
})
export class InventoryListComponent extends ListComponent {
  constructor(
    styleService: StyleService,
    clientService: ClientService,
    apiService: ApiInventoryService,
    buttonHandlerService: ButtonHandlerService,
    location: Location,
    platformLocation: PlatformLocation,
    route: ActivatedRoute,
    router: Router,
    localStorageService: LocalStorageService,
    storageService: SessionStorageService,
    renderer: Renderer2,
    loaderService: LoaderService,
    globalService: GlobalService,
    @Inject(PLATFORM_ID) platformId: any,
    @Inject(DOCUMENT) document: Document,
    @Optional() filtersService: FiltersService) {
    super(
      styleService,
      clientService,
      apiService,
      buttonHandlerService,
      location,
      platformLocation,
      route,
      router,
      localStorageService,
      storageService,
      renderer,
      loaderService,
      globalService,
      platformId,
      document,
      filtersService,
    );
  }

}
